import { render } from "./DepartmentsView.vue?vue&type=template&id=fb0ebd18"
import script from "./DepartmentsView.vue?vue&type=script&lang=js"
export * from "./DepartmentsView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bertog/Code/aitmes/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__